import { useOnline } from '@vueuse/core';
import { Strings } from "@/locales/types/enums";
import { computed, ref, type Ref, watch } from 'vue';

export default defineNuxtPlugin(async (nuxtApp) => {
	const { $i18n } = useNuxtApp();
	const isOffline = computed((): boolean => !useOnline().value);
	const appCreated: Ref<boolean> = ref(false);

	nuxtApp.hook('app:mounted', () => {
		appCreated.value = true;
	});

	watch(
		isOffline,
		(value: boolean): void => {
			if(appCreated.value) {
				return;
			}

			if (value) {
				const modalWrapper = document.createElement('div');
				modalWrapper.className = 'custom-modal';
				const modalContent = `
					<div class="custom-modal__wrapper">
						<div class="custom-modal__title">${$i18n.t(Strings.HOME_NO_INTERNET).toString()}</div>
						<div class="custom-modal__description">${$i18n.t(Strings.HOME_CHECK_CONNECTION).toString()}</div>
						<div class="custom-modal__button-container">
							<button id="btn-internet" class="custom-modal__btn btn" onclick="window.close()" autofocus>${$i18n.t(Strings.SETTINGS_ACCOUNT_MODAL_CLOSE).toString()}</button>
						</div>
					</div>
				`;

				modalWrapper.innerHTML = modalContent;
				document.body.appendChild(modalWrapper);
			} else {
				// eslint-disable-next-line @typescript-eslint/ban-ts-comment
				// @ts-ignore:next-line
				window.location.reload(true);
			}
		}
	);

});